import { useMemo } from 'react';
import { z } from 'zod';

import { useFeatureFlagJson } from 'src/hooks/feature-flag';

export type AgentStreamingConfig = {
  streamdownStaggerMs: number;
  streamdownDurationMs: number;
};

export const DEFAULT_AGENT_STREAMING_CONFIG: AgentStreamingConfig = {
  streamdownStaggerMs: 40,
  streamdownDurationMs: 150,
};

const streamingConfigSchema = z.object({
  streamdownStaggerMs: z.number().int().nonnegative().catch(DEFAULT_AGENT_STREAMING_CONFIG.streamdownStaggerMs),
  streamdownDurationMs: z.number().int().nonnegative().catch(DEFAULT_AGENT_STREAMING_CONFIG.streamdownDurationMs),
});

/** Parses the LaunchDarkly JSON value into complete, safe animation timing values. */
export function parseAgentStreamingConfig(value: z.input<typeof streamingConfigSchema>): AgentStreamingConfig {
  const parsed = streamingConfigSchema.safeParse(value);
  if (!parsed.success) {
    return DEFAULT_AGENT_STREAMING_CONFIG;
  }
  return {
    streamdownStaggerMs: parsed.data.streamdownStaggerMs,
    streamdownDurationMs: parsed.data.streamdownDurationMs,
  };
}

/** Supplies the configured AI assistant Streamdown animation timing. */
export default function useAgentStreamingConfig(): AgentStreamingConfig {
  const flagValue = useFeatureFlagJson('ai-assistant-streaming');
  return useMemo(() => parseAgentStreamingConfig(flagValue), [flagValue]);
}
